export default function IconZoomBrand(props: { size?: number }) {
  const { size = 24 } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <rect width="24" height="24" rx="6" fill="#2d8cff" />
      <rect x="4.5" y="8" width="10" height="8" rx="2" fill="#ffffff" />
      <path
        fill="#ffffff"
        d="M15.8 10.9l3.2-2.3c.26-.19.6 0 .6.3v6.2c0 .31-.34.49-.6.3l-3.2-2.3z"
      />
    </svg>
  );
}
